<template>
  <div :class="['signup',{'signupdhjr':fromdhjr}]">
    <div class="signup-content">
      <div class="info-content">
        <div :class="['content-title',{'content-titledhjr':fromdhjr},{'sm-titledhjr':fromdhjr}]">私募管理人信息</div>
        <div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">公司全称</span>
            <div><input v-model="institutName" :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">中基协登记编号</span>
            <div><input v-model="institutRecordNum" placeholder="P00000001"
                        :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">管理规模</span>
            <div>
              <div :class="['kuang',{'kuangdhjr':fromdhjr}]"><input v-model="assetSize" type="number"
                                                                    @input="assetSize=assetSize.replace(/[^\d^\.]+/g,'')"
                                                                    placeholder="万元"
                                                                    :class="['moreinput',{'moreinputdhjr':fromdhjr}]"/><span
                v-if="assetSize">万元</span></div>
            </div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">联系人</span>
            <div><input v-model="linkman" :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">联系人手机</span>
            <div><input v-model="linkmanMobile" type="number" :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
          <div class="textcontent"><span :class="['text',{'textdhjr':fromdhjr}]">联系人座机</span>
            <div><input v-model="linkmanPhone" :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">联系人邮箱</span>
            <div><input v-model="linkmanEmail" :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
          <div class="textcontent"><span :class="['text',{'textdhjr':fromdhjr}]">QQ</span>
            <div><input v-model="linkmanQQ" :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
        </div>
      </div>
      <div class="info-content" v-for="(item,index) in productVoList" :key="index">
        <div v-if="fromdhjr" class="linedhjr"></div>
        <div :class="['content-title',{'content-titledhjr':fromdhjr}]">参赛产品信息{{index+1}}<span
          v-if="productVoList.length>1&&!fromdhjr" class="delete" @click="reduceProducts(index)"><img
          src="../../assets/delete.png"/> 删除</span><span v-if="productVoList.length>1&&fromdhjr"
                                                         :class="['delete',{'deletedhjr':fromdhjr}]"
                                                         @click="reduceProducts(index)"><img
          src="../../assets/deldhjr.png"/></span></div>
        <div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">参赛产品全称</span>
            <div><input v-model="item.productName" :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">参赛产品简称</span>
            <div><input v-model="item.productShortName" maxlength="10" placeholder="不超过10个字符"
                        :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">中基协备案编码</span>
            <div><input v-model="item.productRecordNum" :class="['mostinput',{'mostinputdhjr':fromdhjr}]"/></div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">参赛产品组别</span>
            <div>
              <div class="levelcon">
                <input v-model="item.groupName" value="3" :class="[{'dhjr':fromdhjr}]" type="radio"/>
                <span :class="['textdet',{'textdetdhjr':fromdhjr}]">CTA及衍生品策略（主要投资于商品及金融衍生品，且投资比例超60%）</span>
              </div>
              <div class="levelcon">
                <input v-model="item.groupName" value="1" :class="[{'dhjr':fromdhjr}]" type="radio"/>
                <span :class="['textdet',{'textdetdhjr':fromdhjr}]">股票策略（主要投资于股票市场，且总头寸占比超60%）</span>
              </div>
              <div class="levelcon">
                <input v-model="item.groupName" value="2" :class="[{'dhjr':fromdhjr}]" type="radio"/>
                <span :class="['textdet',{'textdetdhjr':fromdhjr}]">对冲策略（同时持有资产相关、规模相当的多空头寸策略，且总头寸占比超60%）</span>
              </div>
              <div class="levelcon">
                <input v-model="item.groupName" value="4" :class="[{'dhjr':fromdhjr}]" type="radio"/>
                <span :class="['textdet',{'textdetdhjr':fromdhjr}]">混合策略（采用多种投资策略，且每种策略的投资比例不超过60%）</span>
              </div>
              <div class="levelcon">
                <input v-model="item.groupName" value="5" :class="[{'dhjr':fromdhjr}]" type="radio"/>
                <span :class="['textdet',{'textdetdhjr':fromdhjr}]">其他策略（包括固收、日内等其他各种策略）</span>
              </div>
            </div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">产品最新规模</span>
            <div>
              <div :class="['kuang',{'kuangdhjr':fromdhjr}]"><input v-model="item.productSize" type="number"
                                                                    @input="item.productSize=item.productSize.replace(/[^\d^\.]+/g,'')"
                                                                    placeholder="万元"
                                                                    :class="['moreinput',{'moreinputdhjr':fromdhjr}]"/><span
                v-if="item.productSize">万元</span></div>
            </div>
          </div>
          <div class="textcontent"><span :class="['xing',{'xingdhjr':fromdhjr}]">*</span><span
            :class="['text',{'textdhjr':fromdhjr}]">是否为程序化交易</span>
            <div>
              <div class="cxhcon">
                <input v-model="item.isProcedural" value="1" :class="[{'dhjr':fromdhjr}]" type="radio"/>
                <span :class="['textdet',{'textdetdhjr':fromdhjr}]">是</span>
              </div>
              <div class="cxhcon">
                <input v-model="item.isProcedural" value="0" :class="[{'dhjr':fromdhjr}]" type="radio"/>
                <span :class="['textdet',{'textdetdhjr':fromdhjr}]">否</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-content">
        <div :class="['addproduct',{'addproductdhjr':fromdhjr}]" @click="addproduct">+ 添加参赛产品</div>
        <div :class="['agree',{'agreedhjr':fromdhjr}]" @click="showrules"><input :class="[{'dhjr':fromdhjr}]"
                                                                                 type="checkbox" v-model="hasread"/>我已查看并同意：<a
          @click="showTab('promise',$event)">参赛承诺书</a> <a @click="showTab('rules',$event)">参赛规则</a></div>
        <div v-if="!fromdhjr" class="submit"><img @click="submitInfo" src="../../assets/submit.png"/></div>
        <div v-else class="submitdhjr" @click="submitInfo">提交</div>
      </div>
    </div>
    <promiserules v-if="showpromiserules" :fromdhjr="fromdhjr" :tab="tab" @readagree="readagree"></promiserules>
    <message v-if="message&&!fromdhjr" :message="message" @hidemessage="hidemessage"></message>
    <messagedhjr v-if="message&&fromdhjr" :message="message" @hidemessage="hidemessage"></messagedhjr>
  </div>
</template>
<script>
  import promiserules from './promiserules'
  import {http} from '../../fetch/api'
  import message from './message'
  import messagedhjr from './messagedhjr'

  export default {
    components: {
      promiserules,
      message,
      messagedhjr
    },
    data() {
      return {
        showpromiserules: false,
        tab: "promise",
        institutName: "",
        institutRecordNum: "",
        assetSize: "",
        linkman: "",
        linkmanEmail: "",
        linkmanPhone: "",
        linkmanQQ: "",
        linkmanMobile: "",
        productVoList: [{}],
        hasread: false,
        message: "",
        fromdhjr: false
      }
    },
    mounted() {
      if (this.$route.query.from == 'dhjr') {
        this.fromdhjr = true
      } else {
        this.fromdhjr = false
      }
    },
    methods: {
      hidemessage() {
        this.message = ""
      },
      reduceProducts(index) {
        this.productVoList.splice(index, 1)
      },
      async submitInfo() {
        if (!this.institutName) {
          this.message = '请填写公司全称'
          return
        }
        if (!this.institutRecordNum) {
          this.message = '请填写登记编号'
          return
        }
        if (!this.assetSize) {
          this.message = '请填写管理规模'
          return
        }
        if (!this.linkman) {
          this.message = '请填写联系人'
          return
        }
        if (!this.linkmanMobile) {
          this.message = '请填写联系人手机'
          return
        }
        if (!this.linkmanEmail) {
          this.message = '请填写联系人邮箱'
          return
        }
        var telreg = /^1[3456789]\d{9}$/
        if (!telreg.test(this.linkmanMobile)) {
          this.message = "请输入正确格式的联系人手机号"
          return
        }
        var reg = /([a-zA-Z0-9_\.\-]+)@([a-zA-Z0-9_\.\-]+)\.([a-zA-Z]{2,4})$/
        if (!reg.test(this.linkmanEmail)) {
          this.message = "请输入正确格式的邮箱"
          return
        }
        for (var i = 0; i < this.productVoList.length; i++) {

          if (!this.productVoList[i].productName || !this.productVoList[i].productShortName || !this.productVoList[i].productRecordNum || !this.productVoList[i].groupName || !this.productVoList[i].productSize || !this.productVoList[i].isProcedural) {
            this.message = '请将产品信息填写完整'
            return
          }
        }
        if (!this.hasread) {
          this.message = "请确认阅读参赛承诺书和参赛规则"
          return
        }
        var info = {

          institutName: this.institutName,
          institutRecordNum: this.institutRecordNum,
          assetSize: this.assetSize,
          linkman: this.linkman,
          linkmanEmail: this.linkmanEmail,
          linkmanPhone: this.linkmanPhone,
          linkmanQQ: this.linkmanQQ,
          linkmanMobile: this.linkmanMobile,
          productVoList: this.productVoList,
          from: this.$route.query.from
        }
        this.message = '产品提交中...'
        var data = await http.appProBaoming(info)
        if (data.code == '0') {
          this.message = '报名成功'
        } else {
          this.message = data.msg
        }
      },
      addproduct() {
        if (this.productVoList.length == 8 || this.productVoList.length > 8) {
          this.message = '同一机构最多8个产品参赛'
          return
        } else {
          this.productVoList.push({})
        }

      },
      readagree() {
        this.showpromiserules = false
        this.hasread = true
      },
      showrules() {
        this.showpromiserules = true

      },
      showTab(val, event) {
        this.showpromiserules = true
        this.tab = val
        event.stopPropagation()
      }
    }
  }
</script>
<style scoped>
  .signup {
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    background-image: url("../../assets/rulessettingbg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
  }

  .signupdhjr {
    background-image: none;
  }

  .signup-content {
    padding: 0 6vw 2vw 6vw;
  }

  .info-content {
    position: relative;
  }

  .linedhjr {
    position: absolute;
    height: 3vw;
    background: #f5f5f5;
    width: 100vw;
    left: -6vw;
    top: 5vw;
  }

  .content-title {
    text-align: center;
    color: #fff;
    font-size: 5vw;
    padding-top: 15vw;
    padding-bottom: 5vw;
    position: relative;
  }

  .content-titledhjr {
    color: #3f3f3f;
    font-weight: bold;
    padding-top: 15vw;
  }
  .sm-titledhjr {
    padding-top: 10vw;
  }

  .delete {
    position: absolute;
    right: 0;
    color: #fc1c1c;
    font-size: 4vw;
    top: 15.5vw;
  }

  .delete img {
    width: 3.8vw;
    vertical-align: middle;
  }

  .deletedhjr img {
    width: 5vw;
  }

  .textcontent {
    line-height: 7vw;
    margin-top: 2vw;
  }

  .xing {
    color: #fc1c1c;
  }

  .xingdhjr {
    color: #fda635;
  }

  .text {
    color: #3bbafc;
    font-size: 4vw;
  }

  .textdhjr {
    color: #3f3f3f;
  }

  .mostinput {
    width: 100%;
    border: solid 1px #3cbbfd;
    border-radius: 1vw;
    box-sizing: border-box;
    background: none;
    height: 11vw;
    outline: none;
    color: #fff;
    padding-left: 3vw;
    font-size: 3.5vw;
  }

  .mostinputdhjr {
    border-color: #bebebe;
    -webkit-appearance: none; /* 方法2 */
    color: #3f3f3f;
  }

  .kuang {

    width: 100%;
    border: solid 1px #3cbbfd;
    border-radius: 1vw;
    box-sizing: border-box;
    background: none;
    height: 11vw;
    outline: none;
    color: #fff;
    font-size: 3.5vw;
  }

  .kuangdhjr {
    border-color: #bebebe;
    color: #3f3f3f;
  }

  .moreinput {
    height: 11vw;
    line-height: 11vw;
    width: 20vw;
    background: none;
    border: none;
    outline: none;
    padding-left: 3vw;
    color: #fff;
  }

  .moreinputdhjr {
    color: #33425e;
  }

  input::-webkit-input-placeholder {
    color: #33425e;
    font-size: 3.5vw;
  }

  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #33425e;
    font-size: 3.5vw;
  }

  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #33425e;
    font-size: 3.5vw;
  }

  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #33425e;
    font-size: 3.5vw;
  }

  input.mostinputdhjr::-webkit-input-placeholder {
    color: #bebebe;
    font-size: 3.5vw;
  }

  input.mostinputdhjr::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #bebebe;
    font-size: 3.5vw;
  }

  input.mostinputdhjr:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #bebebe;
    font-size: 3.5vw;
  }

  input.mostinputdhjr:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #bebebe;
    font-size: 3.5vw;
  }

  input.moreinputdhjr::-webkit-input-placeholder {
    color: #bebebe;
  }

  input.moreinputdhjr::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #bebebe;
  }

  input.moreinputdhjr:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #bebebe;
  }

  input.moreinputdhjr:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #bebebe;
  }

  .textdet {
    color: #fff;
    font-size: 4vw;
    padding-left: 6vw;
    display: inline-block;
  }

  .textdetdhjr {
    color: #3f3f3f;
  }

  .levelcon {
    position: relative;
  }

  .cxhcon {
    position: relative;
    display: inline-block;
    margin-right: 15vw;
  }

  input[type="radio"] {
    -webkit-appearance: none; /*清除复选框默认样式*/
    height: 4vw; /*高度*/
    vertical-align: middle;
    width: 4vw;
    outline: none;
    border-radius: 50%;
    background-image: url("../../assets/radio.png");
    background-repeat: no-repeat;
    background-size: contain;
    border: none;
    position: absolute;
    top: 1.8vw;
  }

  input[type='radio'].dhjr {
    background-image: none;
    border: solid 1px #bebebe;
  }

  input[type="radio"]:checked {
    background-image: url("../../assets/radioactive.png");
  }

  input[type="radio"]:checked.dhjr {
    background-image: none;
    background-color: #fda635;
    border: none;
  }

  input[type="checkbox"] {
    -webkit-appearance: none; /*清除复选框默认样式*/
    height: 4vw; /*高度*/
    vertical-align: middle;
    width: 5vw;
    outline: none;
    background-image: url("../../assets/check.png");
    background-repeat: no-repeat;
    background-size: contain;
    border: none;
  }

  input[type="checkbox"]:checked {
    background-image: url("../../assets/checkactive.png");
  }

  input[type="checkbox"].dhjr {
    width: 6vw;
    height: 5vw;
    background-image: url("../../assets/choice_off_orange.png");
  }

  input[type="checkbox"]:checked.dhjr {
    background-image: url("../../assets/choicedhjr.png");
  }

  .addproduct {
    background: #3dbbfd;
    border-radius: 1vw;
    height: 11vw;
    line-height: 11vw;
    text-align: center;
    font-size: 4vw;
    color: #000;
    font-weight: bolder;
    margin-top: 6vw;
  }

  .addproductdhjr {
    color: #fff;
    background: #fda635;
  }

  .agree {
    margin-top: 5vw;
    color: #3bbafc;
    font-size: 4vw;
  }

  .agree a {
    text-decoration: underline;
  }

  .agreedhjr {
    color: #3f3f3f;
  }

  .submit {
    margin: 10vw 0;
  }

  .submitdhjr {
    margin: 10vw 0;
    color: #fff;
    background: #fda635;
    text-align: center;
    width: 88vw;
    height: 11vw;
    line-height: 11vw;
    border-radius: 1vw;
    font-weight: bold;
  }

  .submit img {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/signup.vue